import settings from '@/settings'

const ativarPosto = (cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/postos/ativar/?cnpj=${cnpj}`, {
    method: 'PUT',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const desativarPosto = (cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/postos/desativar/?cnpj=${cnpj}`, {
    method: 'PUT',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const insertByAdmin = (posto, headers) => {
  return fetch(`${settings.apetrusApi}/postos/inserir_pelo_adm/`, {
    method: 'POST',
    body: JSON.stringify(posto),
    mode: 'cors',
    headers: headers
  })
}

const getByAdmin = (cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/postos/pegarporadmin/?cnpj=${cnpj}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const frentistasDoPosto = (headers, filtros) => {
  let url = `${settings.apetrusApi}/frentistas/pegarporadmin/`
  if (filtros) {
    Object.keys(filtros).forEach((filter) => {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${filtros[filter]}`
    })
  }
  return fetch(url,
    {
      method: 'GET',
      mode: 'cors',
      headers: headers
    }
  )
}

const pagarFrentista = (data, headers) => {
  return fetch(`${settings.apetrusApi}/frentistas/pagarfrentista/`, {
    method: 'post',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const getSolicitacoes = (data, headers) => {
  return fetch(
    `${settings.apetrusApi}/frentistas/solicitacoes/?cnpj=${data.cnpj}&id_frentista=${data.id}`,
    {
      method: 'GET',
      mode: 'cors',
      cache: 'default',
      headers: headers
    }
  )
}

const TrocarOuEditar = (data, headers) => {
  return fetch(
    `${settings.apetrusApi}/postos/trocarrepresentante/${data.cnpj}/`,
    {
      method: 'PUT',
      body: JSON.stringify(data),
      mode: 'cors',
      headers: headers
    }
  )
}

const pegarTodos = (headers, filtro) => {
  const keys = Object.keys(filtro)
  let url = `${settings.apetrusApi}/postos/postosativos/?notPaged=true`
  for (let i = 0; i < keys.length; i++) {
    if (
      filtro[keys[i]] !== null &&
      filtro[keys[i]] !== undefined &&
      filtro[keys[i]] !== ''
    ) {
      url = `${url}&${keys[i]}=${filtro[keys[i]]}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const procurarPostosPorAdm = (headers, payload) => {
  let url = `${settings.apetrusApi}/postos/postosativos/?`
  Object.keys(payload.filtros).forEach((filter) => {
    url = `${url}&${filter}=${payload.filtros[filter]}`
  })
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const transferirPosto = (headers, data) => {
  return fetch(`${settings.apetrusApi}/postos/transferir-posto-por-admin/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const atualizarPosto = (headers, data) => {
  return fetch(`${settings.apetrusApi}/postos/${data.cnpj}/atualizar/`, {
    method: 'PUT',
    mode: 'cors',
    cache: 'default',
    body: JSON.stringify(data),
    headers: headers
  })
}

const procurarPostosPorUsuario = (headers, payload) => {
  return fetch(
    `${settings.apetrusApi}/postos/all/?representante=${payload.id_pessoa}&page=${payload.page}`,
    {
      method: 'GET',
      mode: 'cors',
      headers: headers
    }
  )
}

const transferirInformacoes = (headers, payload) => {
  return fetch(
    `${settings.apetrusApi}/postos/transferir-informacoes-por-admin/`,
    {
      method: 'POST',
      mode: 'cors',
      headers: headers,
      body: JSON.stringify(payload)
    }
  )
}

export default {
  ativarPosto,
  desativarPosto,
  insertByAdmin,
  getByAdmin,
  frentistasDoPosto,
  pagarFrentista,
  getSolicitacoes,
  TrocarOuEditar,
  pegarTodos,
  procurarPostosPorAdm,
  transferirPosto,
  atualizarPosto,
  procurarPostosPorUsuario,
  transferirInformacoes
}
